<template>
  <div class="brandImage">
    <div class="headTitle">
      <div class="shadowTxt">VIDEOS</div>
      <div class="title">品牌影像</div>
    </div>
    <div class="videoPart">
      <div class="partCont" v-for="(item, index) in videoList" :key="item.id">
        <div class="videoImg">
          <img :src="item.photo" v-show="!item.videoShow" alt="" />
          <video
            :src="item.video"
            v-show="item.videoShow"
            class="video"
            ref="video1"
            width="100%"
            height="193px"
            @click="handleVideo(item, 'video1', index)"
            controls
            controlslist="nodownload"
            disablepictureinpicture="true"
          ></video>
        </div>
        <div class="play">
          <img
            src="../../assets/images/play.png"
            alt="play"
            class="play"
            v-show="!item.videoShow"
            @click="playItem(item, 'video1', index)"
          />
        </div>
        <div class="title">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetVideos } from "../../api/index";

export default {
  name: "newsDetails",
  metaInfo: {
      title: '品牌影像-爱情地产',
      meta: [{
      name: 'keyWords',
      content: '爱情地产'
      },
      {
      name: 'description',
      content: ''
      }]
  },
  data() {
    return {
      videoList: [],
    };
  },
  created() {
    apiGetVideos().then((data) => {
      if (data.data.status === 1) {
        data.data.videos.forEach((item) => {
          item.photo = "http://www.weaiove.com" + item.photo;
          item.video = "http://www.weaiove.com" + item.video;
          item.videoShow = false;
        });
        data.data.videolist.forEach((item) => {
          item.photo = "http://www.weaiove.com" + item.photo;
          item.video = "http://www.weaiove.com" + item.video;
          item.videoShow = false;
        });
        
        this.videoList = data.data.videos.concat(data.data.videolist);
      }
    });
  },
  methods: {
    playItem(item, name, index = 0) {
      item.videoShow = true;
      this.$refs[name][index].play();
    },
    handleVideo(item, name, index = 0) {
      item.videoShow = false;
      this.$refs[name][index].pause();
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.headTitle {
  padding: 20px 15px 7px 15px;
  background: #fff;
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
  }
}
.videoPart {
  padding: 0 15px 10px;
  .partCont {
    margin-bottom: 10px;
    position: relative;
    .videoImg {
      width: 100%;
      height: 193px;
      img{
        border-radius: 5px;
      }
      video{
        object-fit:fill;
      }
    }
    .play {
      width: 50px;
      height: 50px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -25px;
      margin-top: -25px;
    }
    .title {
      font-family: "苹方-简 中黑体";
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      position: absolute;
      top: 10px;
      left: 10px;
    }
  }
}
</style>
